import { computed } from 'vue';
import { DispatchOptions, useStore } from 'vuex';
import $store from '@/store/index';

export function useActions(actionPaths: string[]) {
  const store = useStore() || $store;

  if (!store) {
    throw new Error(
      'Vuex store is not available. Make sure the store is provided to the app.',
    );
  }

  const actions = actionPaths.map((actionPath) => {
    return (payload?: any, options?: DispatchOptions | undefined) => {
      return store.dispatch(actionPath, payload, options);
    };
  });

  return actions;
}

export function useGetters(actionPaths: string[]) {
  const store = useStore() || $store;

  if (!store) {
    throw new Error(
      'Vuex store is not available. Make sure the store is provided to the app.',
    );
  }

  const getters = actionPaths.map((path) => {
    return computed(() => store.getters[path]);
  });

  return getters;
}

export function useDispatch(paths: string[]) {
  const store = useStore() || $store;

  if (!store) {
    throw new Error(
      'Vuex store is not available. Make sure the store is provided to the app.',
    );
  }

  return paths.map((path) => {
    return (payload) => {
      store.commit(path, payload);
    };
  });
}

export function useState<T>(statePaths: string[]) {
  const store = useStore() || $store;

  if (!store) {
    throw new Error(
      'Vuex store is not available. Make sure the store is provided to the app.',
    );
  }

  const states = statePaths.map((path) => {
    return computed(() => {
      // Access the state using the path.  Handles nested state.
      let currentState = store.state;
      const pathSegments = path.split('/');

      for (const segment of pathSegments) {
        if (
          currentState &&
          typeof currentState === 'object' &&
          segment in currentState
        ) {
          currentState = currentState[segment];
        } else {
          console.warn(
            `State path "${path}" is invalid.  Could not find segment "${segment}". Returning undefined.`,
          );
          return undefined; // Or throw an error, depending on desired behavior
        }
      }
      return currentState;
    });
  });

  return states;
}
